// NATIVE 
import React, { useEffect, useState } from 'react';


// INSTALLED 
import Box from '@mui/material/Box';
import { Form, useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, CardActionArea, CardMedia, Divider, Grid } from '@mui/material';



// CUSTOM 
import { saveCompany } from '../../store/company';
import { uploadImgStore } from '../../store/uploaders';
import { IDatosBasicos } from '../../commons/interfaces';
import { SnackAlert } from '../../components/SnackAlert';
import { LinearProgressWithLabel } from '../../components';
import InputField from '../../components/formFields/InputField';
import { MessagesDrawerRight } from '../../components/MessagesDrawerRight';
import AutocompleteField from '../../components/formFields/autocompleteField';
import { UploadButtonField } from '../../components/formFields/uploadButtonField';
import AutocompleteFieldCountry from '../../components/formFields/autocompleteFieldCountry';
import AutocompleteFieldDepartament from '../../components/formFields/AutocompleteFieldDepartament';
import createSucursalFormModel from '../../components/sucursal/formModels/createSucursalFormModel';
import { getSucursalDataSelects } from '../../store/sucursal';
import { ModalSessionExpired } from '../generics/ModalSessionExpired';
import { timeToClosedToast } from '../../commons';
import MultipleSnackbars from '../MultipleSnackbars';
import { closeSessionGlobal } from '../../commons/utils';
import { useNavigate } from 'react-router-dom';
import editSucursalFormModel from './formModels/edit/editSucursalFormModel';
import { CardActionImage } from '../CardActionImage';








/**
 * SucursalEmpresa component is responsible for rendering a form to create or update a company branch (sucursal).
 * It utilizes Redux for state management and Formik for form handling.
 * 
 * @param {any} props - The properties passed to the component.
 * 
 * @returns {JSX.Element} The rendered component.
 * 
 * @component
 * 
 * @example
 * return (
 *   <SucursalEmpresa />
 * )
 * 
 * @remarks
 * This component includes various form fields such as name, address, country, department, municipality, workplace, landline, cell phone, ARL, associated bank, type of bank account, and account number.
 * It also handles file uploads for the branch logo and displays a preview of the uploaded image.
 * 
 * @requires useDispatch - Redux hook to dispatch actions.
 * @requires useSelector - Redux hook to access the state.
 * @requires useFormikContext - Formik hook to access form context.
 * @requires useState - React hook to manage local state.
 * @requires useEffect - React hook to handle side effects.
 * 
 * @todo
 * - Improve error handling and validation.
 * - Add more detailed comments and documentation for each function and state variable.
 */
export const EditSucursalEmpresa = (props:any) => {

  //  USE DISPATCH 
  const dispatch = useDispatch();


  // NAVIGATION
  const navigate = useNavigate();


  // REDUX
  const { sucursal }:any  = useSelector( (state:any) => state.sucursales );


  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<string[]>([]); 
  const [msgSnack, setMsgSnack] = React.useState({
        msg: '',
        status: 'success'
  });
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  // REDUX
  const { workplace_list_select }:any  = useSelector( (state:any) => state.workplace );

  const { country_list_select }:any  = useSelector( (state:any) => state.country );
  const { departaments_list_select }:any  = useSelector( (state:any) => state.departaments );
  const { municipaly_list_select }:any  = useSelector( (state:any) => state.municipalies );

  const { arl_list_select }:any   = useSelector( (state:any) => state.arl );


  const  {  family_compensation_list_select }:any  = useSelector( (state:any) => state.cajaCompensacion );


  const { associated_bank_select }:any = useSelector( (state:any) => state.associatedbank );
  const { type_account_bank_list_select }:any = useSelector( (state:any) => state.typeaccountbank );



  // DATA FORM MODELS
  const { formId, formField } = editSucursalFormModel;



  // USE STATE 
  const [data, setMsgErrors] = useState([]);
  const [alert_snack, setAlertSnack] = useState(false);
  const [textAlertSnack, setTextAlertSnack] = useState('');
  const [severity, setSeverity] = useState('success');
  
  const [percentaje_c_Company, setPercentajeCCompany] = useState(0);
  const [percentage_upload_sucursal, setPercentageUploadSucursal] = useState(0);
  const [departaments,   setDepartaments]  = useState([]);
  const [activity_economic, setActivityEconomic] = useState([]);
  const [municipalies,   setMunicipalies]  = useState([]);
  const [file_post_name, setSucursalFileName] = useState('');
  const [file_logo_post, setFileSucursal] = useState(null);
  const [preview_sucursal, setPreviewSucursal] = useState('');


//   FORM FIELDS 
  const { 
      e_sucursal_name,
      e_sucursal_address,
      e_country,
      e_departament,
      e_municipaly,
      e_workplace,
      e_family_fund_compensation,
      e_landline,
      e_cell_phone,
      e_arl,
      e_associated_bank,
      e_type_account_bank,
      e_account_number,
      e_logo_sucursal,
    
  } = formField;



  const formikProps:any = useFormikContext();
  


    useEffect(() => {
            
        if ( !sucursal || Object.keys(sucursal).length == 0 ) {
            navigate("/configuracion/sucursales");
        }

    }, [sucursal]);


    useEffect(() => {
        
        if ( !sucursal || Object.keys(sucursal).length == 0 ) {
            navigate("/configuracion/sucursales");
        }

    }, []);

  
    useEffect(() => {
        setData(sucursal);
    }, [sucursal])


   


    const setData = (sucursal:any) => {
      
          console.log('chambabbr ', sucursal)
           
          // ID COMPANY 
          formikProps.setFieldValue('sucursalId', sucursal.id );


          formikProps.setFieldValue('e_sucursal_name', sucursal.name );
          formikProps.setFieldValue('e_sucursal_address', sucursal.address );
          formikProps.setFieldValue('e_country', sucursal.country );
          formikProps.setFieldValue('e_departament', sucursal.departament );
          formikProps.setFieldValue('e_municipaly', sucursal.municipaly );
          formikProps.setFieldValue('e_workplace', sucursal.workplace );
          formikProps.setFieldValue('e_family_fund_compensation', sucursal.familyCompensationFund );
          formikProps.setFieldValue('e_landline', sucursal.landline );
          formikProps.setFieldValue('e_cell_phone', sucursal.cell_phone );
          formikProps.setFieldValue('e_arl', sucursal.arl );
          formikProps.setFieldValue('e_associated_bank', sucursal.associated_bank );
          formikProps.setFieldValue('e_type_account_bank', sucursal.type_account_bank );
          formikProps.setFieldValue('e_account_number', sucursal.account_number );

       
    
    }

   
    useEffect(() => {
        sucursalDataSelects()
    }, []);
    




    const sucursalDataSelects = async() => {
        await  dispatch( getSucursalDataSelects() );
    }
   


  const uploadFileLogoSucursal = async({ target }:any) => {
 
    
      const { name } = target.files[0];
      setSucursalFileName(name);
      setFileSucursal(target.files[0]);

      const objectURL = URL.createObjectURL(target.files[0]);
      setPreviewSucursal(objectURL);

      formikProps.setFieldValue('e_logo_sucursal', target.files[0]);
      const response = await dispatch( uploadImgStore( 'image-sucursal', target.files[0], setPercentageUploadSucursal) );
     

        if (!response.ok) {


            formikProps.setFieldValue('e_logo_sucursal', null);
            setSeverity('error')
            setTextAlertSnack(response.errors[0]);
            setAlertSnack(true);
            return false;
        }

      if (response.ok) {
          formikProps.setFieldValue('e_logo_sucursal_name_saved_file', response.data.imgName);
      }
  
      
  }




return (
  <Box sx={{ width: '100%' }}>

    <ModalSessionExpired  open={modalSessionExpired}  />
    <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
    <SnackAlert open={alert_snack} onclick={setAlertSnack} text={textAlertSnack} severity={severity}/>

    {
         
        sucursal &&  Object.keys(sucursal).length > 0 && 

        <Card style={{ marginTop: 50,  padding: 20}}>
              <Form id={formId}>


            <Grid container spacing={2}>

                {/* GRID 9 COLUMNAS  */}
                <Grid item xs={9}>

                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <InputField 
                                name={e_sucursal_name.name}
                                label={e_sucursal_name.label}
                                variant="outlined" 
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <InputField 
                                name={e_sucursal_address.name}
                                label={e_sucursal_address.label}
                                variant="outlined" 
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <AutocompleteField 
                                options={workplace_list_select}
                                name={e_workplace.name}
                                label={e_workplace.label}
                            />
                        </Grid>
                    </Grid>



                    <Grid container spacing={2} style={{ marginTop: 15 }}>
                        <Grid item xs={4}>
                            <AutocompleteFieldCountry
                                options={country_list_select}
                                name={e_country.name}
                                label={e_country.label}
                                element={e_country.name}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <AutocompleteFieldDepartament 
                                options={departaments_list_select}
                                name={e_departament.name}
                                label={e_departament.label}
                                element={e_departament.name}
                            />
                        </Grid>
                        <Grid item xs={4}> 
                            <AutocompleteField 
                                options={municipaly_list_select}
                                name={e_municipaly.name}
                                label={e_municipaly.label}
                                element={e_municipaly.name}
                            />
                        </Grid>
                    </Grid> 


                    <Grid container spacing={2} style={{ marginTop: 15 }}>
                        <Grid item xs={4}>
                        <AutocompleteField 
                            options={family_compensation_list_select}
                            name={e_family_fund_compensation.name}
                            label={e_family_fund_compensation.label}
                            element={e_family_fund_compensation.name}
                        />
                        </Grid>
                        <Grid item xs={4}>
                        <InputField 
                            name={e_landline.name}
                            label={e_landline.label}
                            variant="outlined" 
                            fullWidth
                        />
                        </Grid>
                        <Grid item xs={4}>
                        <InputField 
                            name={e_cell_phone.name}
                            label={e_cell_phone.label}
                            variant="outlined" 
                            fullWidth
                        />
                        </Grid>
                    </Grid> 


                    <Grid container spacing={2} style={{ marginTop: 15 }}>
                        <Grid item xs={3}>
                            <AutocompleteField
                            options={arl_list_select}
                            name={e_arl.name}
                            label={e_arl.label}
                            element={e_arl.name}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <AutocompleteField
                            options={associated_bank_select}
                            name={e_associated_bank.name}
                            label={e_associated_bank.label}
                            element={e_associated_bank.name}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <AutocompleteField
                            options={type_account_bank_list_select}
                            name={e_type_account_bank.name}
                            label={e_type_account_bank.label}
                            element={e_type_account_bank.name}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <InputField
                                name={e_account_number.name}
                                label={e_account_number.label}
                                variant="outlined" 
                                fullWidth
                            />
                        </Grid>
                    </Grid>


                </Grid>
                {/* END GRID 9 COLUMNAS */}


                {/* GRID 3 COLUMNAS  */}
                 <Grid item xs={3}>

                    <Grid item xs={12}>
                      <Button>  Editar Logo Post Comercial</Button>
                      <Divider/>
                      <UploadButtonField onChange={uploadFileLogoSucursal} 
                                      accept={'image/*'} 
                                      name={e_logo_sucursal.name} 
                                      label={e_logo_sucursal.label} 
                                      text={'Subir Archivo'} />
                      
                      {
                        formikProps.values.e_logo_sucursal
                      
                          ?
                              <>
                              <Card sx={{ maxWidth: 345, marginTop: 2 }}>
                                  <CardActionArea>
                                  <CardMedia
                                      component="img"
                                      height="140"
                                      sx={{ objectFit: 'contain' }}
                                      image={preview_sucursal}
                                      alt="Q"
                                  />
                                  </CardActionArea>
                              </Card>
                              <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                                <LinearProgressWithLabel percentage={percentage_upload_sucursal} label={formikProps.values.e_logo_sucursal.name} hasIcon={false} />
                              </Card>
                              </>
                            :
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <CardActionImage urlImage={sucursal.logo} typeImage={'branch'} />
                            </div>
                      }
                  </Grid>
                 </Grid>
                {/* END GRID 3 COLUMNAS  */}
            
            </Grid>
              
              
              
              
              
            
             

          
          </Form>
        </Card>

    }
   
      
      
      

        
      
  </Box>
)
}